<template>
  <a-modal
    v-model="visible"
    :title="title"
    :footer="null"
    :closable="false"
    class="adaptive-modal"
    @cancel="closeModal"
  >
    <div class="d-flex flex-column">
      <p v-if="text" class="font-size-16" v-html="text" />
      <div class="d-flex flex-column justify-content-center">
        <a-form-model :model="form" ref="form">
          <a-form-model-item
            label="Email"
            prop="email"
            :colon="false"
            :rules="[{ required: true, message: 'Email is required', trigger: ['change'] }]"
          >
            <a-input
              v-model="form.email"
              placeholder="Email"
              size="large"
              :disabled="loading"
            />
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-row class="adaptive-modal__footer">
        <div class="d-flex align-items-center justify-content-end">
          <a-button class="mr-3" @click="closeModal">
            Cancel
          </a-button>
          <a-button
            type="primary"
            :disabled="loading"
            :loading="loading"
            @click="action"
          >
            Export
          </a-button>
        </div>
      </a-row>
    </div>
  </a-modal>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  data: () => ({
    form: {
      email: '',
    },
  }),
  watch: {
    show: {
      handler(val) {
        if (!val) {
          this.visible = false
          return
        }
        this.visible = true
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
  },
  methods: {
    action() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false
        }

        this.$emit('confirm', this.form.email)
      })
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>
